export default __webpack_public_path__ + "static/media/balloon.05df763a.png";